<p-dialog
  [visible]="visible()"
  (onHide)="cancel()"
  [modal]="true"
  [closable]="false"
  [style]="{ width: '560px' }"
  aria-label="communication-category-dialog"
  data-testid="communication-category-dialog">

  <ng-template pTemplate="header">
    <div class="flex justify-content-between align-items-center w-full px-4 py-3 border-bottom-1 surface-border">
      <div>
        <h3 class="m-0 text-sm font-semibold text-900" data-testid="communication-category-form-title">
          {{
            (isEditMode
              ? 'COMMUNICATION_CATEGORIES.FORM.EDIT_TITLE'
              : 'COMMUNICATION_CATEGORIES.FORM.CREATE_TITLE') | translate
          }}
        </h3>
        <p class="text-500 text-xs mt-0 mb-0">
          {{
            (isEditMode
              ? 'COMMUNICATION_CATEGORIES.FORM.EDIT_SUBTITLE'
              : 'COMMUNICATION_CATEGORIES.FORM.CREATE_SUBTITLE') | translate
          }}
        </p>
      </div>
      <button
        type="button"
        class="p-ripple p-button p-component p-button-icon-only p-button-secondary p-button-rounded p-button-text"
        (click)="cancel()"
        aria-label="close-communication-category-form-button"
        data-testid="close-communication-category-form-button">
        <span class="p-button-icon pi pi-times"></span>
      </button>
    </div>
  </ng-template>

  @if (form) {
    <form [formGroup]="form" (ngSubmit)="submit()" data-testid="communication-category-form">
      <div class="flex flex-column gap-3 px-4 py-3">
       

        

        <div>
          <input
            id="communication-category-name"
            pInputText
            type="text"
            formControlName="name"
            class="w-full text-sm"
            [placeholder]="'COMMUNICATION_CATEGORIES.FORM.NAME_PLACEHOLDER' | translate"
            aria-label="communication-category-name-input"
            data-testid="communication-category-name-input" />
          @if (nameControl?.touched && nameControl?.errors?.['required']) {
            <small class="p-error block mt-1" data-testid="communication-category-name-error">
              {{ 'COMMUNICATION_CATEGORIES.FORM.NAME_REQUIRED' | translate }}
            </small>
          }
          @if (nameControl?.touched && nameControl?.errors?.['maxlength']) {
            <small class="p-error block mt-1">
              {{ 'COMMUNICATION_CATEGORIES.FORM.NAME_MAX_LENGTH' | translate }}
            </small>
          }
        </div>
        
          <div>
            <input
              id="communication-category-code"
              pInputText
              type="text"
              formControlName="code"
              class="w-full text-sm"
              [placeholder]="'COMMUNICATION_CATEGORIES.FORM.CODE_PLACEHOLDER' | translate"
              aria-label="communication-category-code-input"
              data-testid="communication-category-code-input" />
            @if (codeControl?.touched && codeControl?.errors?.['maxlength']) {
              <small class="p-error block mt-1">
                {{ 'COMMUNICATION_CATEGORIES.FORM.CODE_MAX_LENGTH' | translate }}
              </small>
            }
          </div>

        <div>
          <textarea
            id="communication-category-description"
            pInputTextarea
            formControlName="description"
            class="w-full text-sm"
            rows="3"
            [placeholder]="'COMMUNICATION_CATEGORIES.FORM.DESCRIPTION_PLACEHOLDER' | translate"
            aria-label="communication-category-description-input"
            data-testid="communication-category-description-input">
          </textarea>
          @if (descriptionControl?.touched && descriptionControl?.errors?.['maxlength']) {
            <small class="p-error block mt-1">
              {{ 'COMMUNICATION_CATEGORIES.FORM.DESCRIPTION_MAX_LENGTH' | translate }}
            </small>
          }
        </div>

        @if (isEditMode) {
          <div class="flex align-items-center gap-2">
            <p-toggleswitch formControlName="status" aria-label="communication-category-status-toggle" />
            <label class="text-sm text-700 mb-0" for="communication-category-status">
              {{ 'COMMUNICATION_CATEGORIES.FORM.ACTIVE' | translate }}
            </label>
          </div>
        }
      </div>

      @if (showAuditLogsFeature && activeCategory()?.id) {
        <div class="px-4 pb-3 border-top-1 surface-border">
          <fitness-force-audit-trail-mini entityType="communication_category_mst"
            [entityId]="activeCategory()!.id"
            [tenantId]="tenantId()"
            [tenantData]="[]"
            [maxEvents]="10"
            [showStats]="true"
            [showFilters]="true"
            [showPagination]="true"
            [showCloseButton]="false"
            height="40vh"
            title="Communication Category Activity Log"
            data-testid="audit-trail-mini-component" />
        </div>
      }
    </form>
  }

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2 px-4 py-3 border-top-1 surface-border">
      <p-button
        [label]="'ADMIN.COMMON.CANCEL' | translate"
        severity="secondary"
        [outlined]="true"
        size="small"
        (onClick)="cancel()"
        aria-label="cancel-communication-category-button"
        data-testid="cancel-communication-category-button" />
      <p-button
        [label]="(isEditMode ? 'ADMIN.COMMON.UPDATE' : 'ADMIN.COMMON.SAVE') | translate"
        [loading]="isSubmitting()"
        [disabled]="form?.invalid ?? true"
        size="small"
        (onClick)="submit()"
        aria-label="save-communication-category-button"
        data-testid="save-communication-category-button" />
    </div>
  </ng-template>
</p-dialog>
